import { render, staticRenderFns } from "./BSelect.vue?vue&type=template&id=3f31aae4"
import script from "./BSelect.vue?vue&type=script&lang=js"
export * from "./BSelect.vue?vue&type=script&lang=js"
import style0 from "./BSelect.vue?vue&type=style&index=0&id=3f31aae4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports